import { SET_PERFORMANCE_DATA } from '../actions/types';

export default (state = null, action) => {
  switch (action.type) {
    case SET_PERFORMANCE_DATA:
      return action.payload;
    default:
      return state;
  }
};
